/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_Owner_LastInputs */

const cs_franchise_create_owner_last = /** @type {(inputs: Franchise_Create_Owner_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příjmení majitele`)
};

const en_franchise_create_owner_last = /** @type {(inputs: Franchise_Create_Owner_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner last name`)
};

/**
* | output |
* | --- |
* | "Owner last name" |
*
* @param {Franchise_Create_Owner_LastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_owner_last = /** @type {((inputs?: Franchise_Create_Owner_LastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_Owner_LastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_owner_last(inputs)
	return cs_franchise_create_owner_last(inputs)
});